import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';

export function TooltipMain(props) {
  return (
    <Tooltip title={props.message} placement="right" arrow>
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}
